import { apiRequest } from './client'
import { demoBillingOverview } from '../dev/buyerDemoData'
import { withDemoUi } from '../dev/demoMode'

export type PlanPriceDto = {
  plan: string
  display_name: string
  monthly_rub: number
  yearly_rub: number | null
  description: string
  seat_limit: number
  base_venue_limit: number
  max_employees_per_venue?: number
  devices_per_user_limit: number | null
  max_private_suppliers: number | null
  private_supplier_refresh_days: number | null
  market_catalog_enabled: boolean
  platform_rfq_enabled: boolean
  platform_chat_enabled: boolean
  buyer_suppliers_enabled: boolean
  market_price_intelligence_enabled: boolean
}

export type OrganizationSubscriptionDto = {
  plan: string
  plan_display_name: string
  subscription_status: string
  subscription_status_display_name: string
  billing_interval: string | null
  period_end: string | null
  paid_venue_slots: number
  seats_used: number
  seats_limit: number
  venues_used: number
  venues_limit: number
}

export type PremiumQuoteDto = {
  venue_count: number
  monthly_rub: number
  yearly_rub: number
  addon_venue_slots: number
}

export type OrganizationBillingOverviewDto = {
  catalog: PlanPriceDto[]
  addon_venue_monthly_rub: number
  addon_venue_yearly_rub: number
  premium_base_venues: number
  current: OrganizationSubscriptionDto
  premium_quote: PremiumQuoteDto
}

export const fetchOrganizationBilling = async (organizationId: number, venueCount?: number) =>
  withDemoUi(demoBillingOverview(), async () => {
  const params = new URLSearchParams()
  if (venueCount != null) {
    params.set('venue_count', String(venueCount))
  }
  const query = params.toString()
  return apiRequest<OrganizationBillingOverviewDto>(
    `/organizations/${organizationId}/billing${query ? `?${query}` : ''}`,
  )
})
